import Vue from 'vue'
import axios from 'axios'
import { pushAppErrorEvent, pushApiErrorEvent } from '@/util/gtm'

// Add a response interceptor
axios.interceptors.response.use(response => {
  // Do something with response data
  return response
}, error => {
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    // console.log(error.response.data)
    // console.log(error.response.status)
    // console.log(error.response.headers)
    pushApiErrorEvent(error.config.url, JSON.stringify({
      status: error.response.status,
      data: error.response.data
    }))
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    // console.log(error.request)
    pushApiErrorEvent(error.config.url, String(error))
  } else {
    // Something happened in setting up the request that triggered an Error
    // console.log(error.message)
    pushApiErrorEvent(error.config.url, error.message)
  }
  // console.log('error.config', error.config.url)
  // pushApiErrorEvent(error.config.url, error)
  return Promise.reject(error)
})

// Track JS errors inside Vue instances
Vue.config.errorHandler = (err, vm, info) => {
  pushAppErrorEvent(info, err.stack)
  console.log('Vue instance Exception JS: ', info, err)
}

// Track JS errors outside Vue instances
window.onerror = (message, source, lineno, colno, error) => {
  pushAppErrorEvent('global', JSON.stringify({ message, source, lineno, colno, error: error.stack }))
  console.log('App Exception JS: ', { message, source, lineno, colno, error })
}
